var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 29,
    viewBox: "0 0 41 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.86621 3.3667H24.2666C25.0212 3.3667 25.6335 3.97833 25.6338 4.73291C25.6338 5.4877 25.0214 6.1001 24.2666 6.1001H1.86621C1.11163 6.09985 0.5 5.48755 0.5 4.73291C0.500246 3.97848 1.11178 3.36695 1.86621 3.3667Z",
    fill: "#008C15",
    stroke: "#008C15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.86621 14.5667H16.7998C17.5544 14.5667 18.1667 15.1783 18.167 15.9329C18.167 16.6877 17.5546 17.3 16.7998 17.3H1.86621C1.11163 17.2998 0.5 16.6875 0.5 15.9329C0.500246 15.1784 1.11178 14.5669 1.86621 14.5667Z",
    fill: "#008C15",
    stroke: "#008C15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.86621 25.7666H9.33301C10.0876 25.7666 10.6999 26.3782 10.7002 27.1328C10.7002 27.8876 10.0878 28.5 9.33301 28.5H1.86621C1.11163 28.4998 0.5 27.8874 0.5 27.1328C0.500246 26.3784 1.11178 25.7668 1.86621 25.7666Z",
    fill: "#008C15",
    stroke: "#008C15"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7324 1V27.1333",
    stroke: "#008C15",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2676 19.6667L31.7342 27.1334L39.2009 19.6667",
    stroke: "#008C15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/SortIcon.8959597822fce5e79e77ba5f22d90f75.svg";
export { ForwardRef as ReactComponent };